<template>
    <div class="main-content" v-cloak>
        <div class="container">
            <div class="error-container">
                <div class="error-header">
                    Oh snap!
                </div>
                <div class="error-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12ZM15.3536 8.64645C15.5488 8.84171 15.5488 9.15829 15.3536 9.35355L12.7071 12L15.3536 14.6464C15.5488 14.8417 15.5488 15.1583 15.3536 15.3536C15.1583 15.5488 14.8417 15.5488 14.6464 15.3536L12 12.7071L9.35355 15.3536C9.15829 15.5488 8.84171 15.5488 8.64645 15.3536C8.45118 15.1583 8.45118 14.8417 8.64645 14.6464L11.2929 12L8.64645 9.35355C8.45118 9.15829 8.45118 8.84171 8.64645 8.64645C8.84171 8.45118 9.15829 8.45118 9.35355 8.64645L12 11.2929L14.6464 8.64645C14.8417 8.45118 15.1583 8.45118 15.3536 8.64645Z"
                            fill="#D30000"
                        />
                    </svg>
                </div>
                <div>
                    <div class="error-msg">Your payment failed!</div>
                    <div class="error-msg-bottom centered">
                        Please try again. Get help!
                    </div>
                    <div class="form-submit centered">
                        <a @click="$router.go(-1)" class="btn-default" href="javascript:{}">Refresh</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    mounted() {},
    computed: {},
    beforeRouteEnter(to, from, next) {
        next(vm => {});
    },
    methods: {
        refresh() {}
    }
};
</script>

<style scoped>
.error-icon svg {
    width: 63.33px;
    height: 63.33px;
}
.error-container {
    margin-bottom: 4.2rem;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}
</style>
